import { useMutation, UseMutationResult } from "@tanstack/react-query"
import buildCarrotApiRetryPolicy from "../../../../../../utils/CarrotApiRetryPolicy"
import { carrotClient } from "utils/CarrotClient"

export default function useMutationMarkScaSetupAsCompleted(): UseMutationResult {
  return useMutation(() => carrotClient.markScaSetupAsCompleted(), {
    retry: buildCarrotApiRetryPolicy(1)
  })
}
